import { TQualityBand } from 'partner360/components/qualityIndicator'

/** The Achievement score's own bands: short of 80% of plan is red, 80 up to plan is amber, and
 *  reaching plan is green — the score is capped at 100 by `getFinancialAchievementScore` /
 *  `getSobAchievementScore`, so `>= 100` is exactly "plan met". Deliberately not Plan Quality's
 *  `getQualityBand` cutoffs; only the resolved colors are shared, via `getQualityBandColor`. */
const MODERATE_SCORE_MIN = 80
const HIGH_SCORE_MIN = 100

/** `null` for a score with no value — the caller then keeps its own neutral gray. */
export const getAchievementScoreBand = (score: number | null): TQualityBand | null => {
  if (score === null || !Number.isFinite(score)) {
    return null
  }

  if (score < MODERATE_SCORE_MIN) {
    return 'Low'
  }

  return score < HIGH_SCORE_MIN ? 'Moderate' : 'High'
}
